import React from 'react';

const Sliders = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Sliders</h2>
    <p className="text-gray-600">This is the Sliders page.</p>
  </div>
);

export default Sliders;
